module.exports = "/images/JR_Pay_Purple.png";